import {
  Box, Button, Container, Flex, Heading, Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { generate } from 'shortid';
import { HalfByHalfSection } from '../_index';

const ContentBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      A
      {' '}
      <span className="highlight">Stress Free Solution</span>
      {' '}
      to Sell Your
      Home in the Bay Area, CA
    </Heading>
    <Text fontSize="2xl">
      I’m sure you know of friends and family who have had horrible experiences
      regarding a sale of property in the Bay Area with an agent. You can avoid
      any headache and stress with us - we offer more money, quality service,
      and an overall better experience!
    </Text>
    <Link to="/get-offer">
      <Button
        mt={10}
        variant="btnCTA"
        size="lg"
        isLoading={false}
        type="submit"
      >
        Get Your Free offer
      </Button>
    </Link>
  </>
);

const FlareBlock = ({ img, flare }) => (
  <Box
    mx="auto"
    mt={6}
    width={{ base: 'auto', md: '300px', ld: '400px' }}
    transform={{ base: 'scale(.8)', md: 'scale(1)' }}
    className="height-400 height-md-500"
    display={{ sm: 'block', md: 'block' }}
    position="relative"
  >
    <Box
      position="absolute"
      top={{ base: '-20%', md: '0%' }}
      left="0%"
    >
      {flare && (
      <GatsbyImage
        alt="hero success image"
        image={flare}
      />
      )}
    </Box>
  </Box>
);

const StressFreeSection = () => {
  const { flareImage, mainImage } = useStaticQuery(query);
  const image = getImage(mainImage);
  const flare = getImage(flareImage);
  return (
    <Container maxW="container.xl">
      <HalfByHalfSection
        reverse
        left={<ContentBlock />}
        right={(
          <FlareBlock
            img={image}
            flare={flare}
          />
)}
      />
    </Container>
  );
};

export const query = graphql`
  query {
    mainImage: file(relativePath: { eq: "business-woman-circle.png" }) {
      childImageSharp {
        gatsbyImageData(width: 600, placeholder: BLURRED)
      }
    }
    flareImage: file(relativePath: { eq: "ill-group-2.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default StressFreeSection;
